import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../contexts/ThemeContext';
import * as FiIcons from 'react-icons/fi';

const { FiActivity, FiSun, FiMoon } = FiIcons;

const Header = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="container mx-auto px-4 py-4 max-w-6xl">
        <div className="flex items-center justify-between">
          <motion.div
            className="flex items-center space-x-2 sm:space-x-3 min-w-0 flex-1"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="p-1.5 sm:p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg flex-shrink-0">
              <SafeIcon icon={FiActivity} className="h-5 sm:h-6 w-5 sm:w-6 text-primary-600 dark:text-primary-400" />
            </div>
            <div className="min-w-0 flex-1">
              <h1 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white truncate">
                Web Down Status
              </h1>
              <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 hidden sm:block">
                Check website availability and performance
              </p>
            </div>
          </motion.div>

          <div className="flex items-center space-x-2 flex-shrink-0">
            <motion.button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors focus-ring"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
            >
              <SafeIcon icon={isDark ? FiSun : FiMoon} className="h-4 sm:h-5 w-4 sm:w-5 text-gray-600 dark:text-gray-400" />
            </motion.button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;